import api from './api';

export type RecebimentoStatus = 'pendente' | 'pago' | 'vencido' | 'cancelado';
export type Frequencia = 'mensal' | 'quinzenal' | 'anual';

export interface Recebimento {
    id: number;
    descricao: string;
    valor: number;
    data_recebimento: string;
    status: RecebimentoStatus;
    origem: 'manual' | 'asaas';
    asaas_id?: string | null;
    entidade_id?: number | null;
    categoria_id?: number | null;
    entidade_nome?: string;
    categoria_nome?: string;
    is_recorrente?: boolean;
    total_parcelas?: number;
    parcela_atual?: number;
    grupo_recorrencia?: string | null;
    // Recorrência real
    frequencia?: Frequencia | null;
    proxima_geracao?: string | null;
    recorrencia_origem_id?: number | null;
}

export interface RecebimentosListFilters {
    mes?: string;
    ano?: string;
    data_inicio?: string;
    data_fim?: string;
    /** Por default cancelados são ocultos. Setar true para incluir. */
    incluir_cancelado?: boolean;
}

export const recebimentosService = {
    list: async (filters?: RecebimentosListFilters) => {
        const response = await api.get<Recebimento[]>('/recebimentos', { params: filters });
        return response.data;
    },
    create: async (data: Partial<Recebimento>) => {
        const response = await api.post('/recebimentos', data);
        return response.data;
    },
    update: async (id: number, data: Partial<Recebimento>) => {
        const response = await api.put(`/recebimentos/${id}`, data);
        return response.data;
    },
    delete: async (id: number) => {
        await api.delete(`/recebimentos/${id}`);
    },
    /** Marca o recebimento como recebido em 1 chamada — atalho da UI. */
    marcarRecebido: async (id: number, dataRecebimento?: string): Promise<Recebimento> => {
        const response = await api.post(`/recebimentos/${id}/marcar-recebido`, {
            data_recebimento: dataRecebimento ?? new Date().toISOString().substring(0, 10),
        });
        return response.data;
    },
};
